import React from "react";
import { useNavigate } from "react-router";
import Avatar from "../../../../components/ui/avatar/Avtar";
import Progressbar from "../../../../components/ui/progressbar/Progressbar";
import { getProjectGradient } from "../../../../lib/getProjectGradient";
import { encryptUrlData } from "../../../../services/CryptoService";

const MAX_PROJECTS = 8;

const STATS = [
  { key: "myOpenTaskCount", label: "Open" },
  { key: "overdueTaskCount", label: "Overdue" },
  { key: "dueTodayTaskCount", label: "Due Today" },
  { key: "completedTaskCount", label: "Completed" },
];

const MyProjectsWidget = ({ projects = [], isLoading }) => {
  const navigate = useNavigate();
  const visible = (projects || []).slice(0, MAX_PROJECTS);

  const openProject = (project) => {
    if (project?.projectId) {
      navigate(`/myprojects/tasklist/${encryptUrlData(project)}`);
    }
  };

  return (
    <div className="dashboard-card my-projects-widget">
      <div className="my-projects-widget__header">
        <h3>My Projects</h3>
        <button type="button" onClick={() => navigate("/MyProjects")}>
          View All
        </button>
      </div>

      {isLoading ? (
        <p className="my-projects-widget__empty">Loading projects…</p>
      ) : visible.length === 0 ? (
        <p className="my-projects-widget__empty">No projects yet</p>
      ) : (
        <ul className="my-projects-widget__list">
          {visible.map((project) => (
            <li key={project.projectId}>
              <button type="button" className="my-projects-widget__item" onClick={() => openProject(project)}>
                <Avatar
                  src=""
                  alt={project.projectName}
                  fallbackText={project.projectCode || undefined}
                  size="small"
                  shape="circle"
                  gradient={getProjectGradient(project.projectId)}
                />
                <div className="my-projects-widget__body">
                  <div className="my-projects-widget__title-row">
                    <strong>{project.projectName}</strong>
                    <span>{project.projectCode}</span>
                  </div>

                  <div className="my-projects-widget__stats">
                    {STATS.map((stat) => (
                      <div className="my-projects-widget__stat" key={stat.key}>
                        <em>{project[stat.key] ?? 0}</em>
                        <span>{stat.label}</span>
                      </div>
                    ))}
                  </div>

                  <Progressbar value progress={Number(project.progressPercent) || 0} />
                </div>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default MyProjectsWidget;
